<template>
    <!-- hover:shadow-xl -->
    <div
        class="w-full mb-3 bg-white  transition-all h-16 rounded-md px-4 flex flex-row justify-between items-center border "
    >
        <div
            class=" file-name-box flex flex-row justify-start items-center"
            style="width: calc(100% - 100px)"
        >
            <component :is="fileIcon" :fillClass="'fill-primary'"></component>

            <div class="ml-4 " style="width: calc(100% - 40px)">
                <h3
                    class=" text-black whitespace-nowrap overflow-ellipsis overflow-hidden w-full "
                >
                    {{ media.name }}
                </h3>

                <p class="text-s text-grey -mt-1">{{ media.size }}</p>
            </div>
        </div>
        <div
            class="flex flex-row items-center justify-end"
        >
            <icon-container
                class="hover:bg-white-dark transition-all bg-transparent"
                icon="LinkedIcon"
                :iconSize="'4'"
                iconFill="fill-grey"
                @click="OPEN_MEDIA_IN_NEW_TAB"
            />

            <icon-container
                class="hover:bg-white-dark transition-all bg-transparent ml-2"
                icon="DownloadIcon"
                :iconSize="'6'"
                iconFill="fill-primary"
                @click="DOWNLOAD_MEDIA"
            />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import IconContainer from "../../components/helper/IconContainer.vue";
import { MEDIA_TYPES, STORE_TYPES } from "../../store/types";
import { resolveFileIconName } from "../../common/fileTypeHelper";
import CustomButton from "../../components/input/CustomButton.vue";
import LinkedIcon from "../../components/icons/LinkedIcon.vue";

export default defineComponent({
    name: "DocumentsContainer",
    components: { IconContainer, CustomButton, LinkedIcon },
    emits: ["openMedia"],
    props: { media: { required: true }, inCourse: { required: false } },
    setup(props, ctx) {
        const store = useStore();
        const state = reactive({});

        function DOWNLOAD_MEDIA() {
            store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.DOWNLOAD_MEDIA}`,
                { media: props.media }
            );
        }

        function OPEN_MEDIA_IN_NEW_TAB() {
            store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.OPEN_MEDIA_IN_NEW_TAB}`,
                { media: props.media }
            );
        }
        /**
         *  Computed
         */
        const fileIcon = computed(() => {
            return resolveFileIconName(props.media.name);
        });

        function openMedia() {
            ctx.emit("openMedia");
        }

        return {
            state,
            fileIcon,
            OPEN_MEDIA_IN_NEW_TAB,
            DOWNLOAD_MEDIA,
            openMedia,
        };
    },
});
</script>
